module.exports = __webpack_public_path__ + "static/media/coingossip-details.b5a08e1c.png";